<script>
    import {Bar, mixins} from 'vue-chartjs';

    export default {
        name   : "MenuStatsTimeChart",
        extends: Bar,
        mixins : [mixins.reactiveProp],
        props  : {
            chartData: {
                type   : Object,
                default: null
            },
            options  : {
                type   : Object,
                default: null
            },
            period   : {
                type   : String,
                default: null
            }
        },
        mounted() {
            this.renderChart(
                this.chartData,
                {
                    responsive         : true,
                    maintainAspectRatio: false,
                    legend             : {
                        display: false,
                    },
                    scales             : {
                        xAxes: [{
                            type        : 'time',
                            distribution: 'series',
                            offset      : true,
                            ticks       : {
                                autoSkip       : true,
                                source         : 'data',
                            },
                            time        : this.getxAxesTimeOptions(),
                            gridLines: {
                                // display: false
                            }
                        }],
                        yAxes: [{
                            stacked: true,
                            ticks  : {
                                autoSkip       : true,
                                maxTicksLimit  : 1,
                                min            : 0,
                            },
                            gridLines: {
                                display: false
                            }
                        }]
                    },
                    tooltips: {
                        position: 'nearest',
                    },
                }
            );
        },
        methods: {
            getxAxesTimeOptions() {
                if (this.period === 'today' || this.period === 'yesterday') {
                    return {
                        minUnit       : 'hour',
                        displayFormats: {
                            hour: 'H:mm',
                        },
                        tooltipFormat: 'D MMM YYYY HH:mm',
                    };
                }

                return {
                    unit: 'day',
                    tooltipFormat: 'MMM D, YYYY',
                };
            }
        }
    }
</script>

<style scoped>

</style>
